import React from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';


export default class FormatDate extends React.PureComponent {
  render() {
    const {date, format} = this.props;

    return dayjs(date).format(format);
  }
}



// WEBPACK FOOTER //
// ./components/dates/FormatDate.js